import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useInstallPrompt from "../../hooks/useInstallPrompt";

export default function InstallPrompt() {
  const { open, platform, install, dismiss } = useInstallPrompt();

  return (
    <Dialog
      open={open}
      onClose={dismiss}
      aria-labelledby="install-dialog-title"
      aria-describedby="install-dialog-description"
    >
      <DialogTitle id="install-dialog-title">Instalar Lawyers</DialogTitle>
      <DialogContent>
        <DialogContentText id="install-dialog-description">
          {platform === "ios" ? (
            <>
              Instala esta app en tu iPhone: toca el botón{" "}
              <strong>Compartir</strong> y luego{" "}
              <strong>&quot;Agregar a inicio&quot;</strong>.
            </>
          ) : (
            "Instala Lawyers en tu dispositivo para acceder más rápido, incluso sin conexión."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={dismiss}>Ahora no</Button>
        {platform !== "ios" && (
          <Button onClick={install} autoFocus>
            Instalar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
